/* eslint-disable no-console */
import axios from 'axios';

const filterForm = document.querySelector('#blogFilter');

const fetchArticles = (params) => {
	return new Promise((resolve) => {
		const url = 'assets/components/canadianaffair/getArticles.php';

		axios
			.get(url, { params: new URLSearchParams(params) })
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				console.error(error);
			});
	});
};

const debounce = (func, wait = 400) => {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, wait);
	};
};

if (filterForm) {
	const searchResultsEl = document.querySelector('#blogResults');
	const blogResultsContainerEl = document.querySelector('#blogResultsContainer');
	const blogNoResultsEl = document.querySelector('#blogNoResults');
	const blogPagingEl = document.querySelector('#blogPaging');
	const informationTextEl = filterForm.querySelector('#informationText');
	const filterCountEl = filterForm.querySelector('#filterCount');
	const resetBlogFilterBtn = filterForm.querySelector('#resetBlogFilter');

	const blogInputEl = filterForm.querySelector('#blogSearch');
	const filterTagsContainerEl = filterForm.querySelector('.fliter-tags');
	const filterTagsEls = filterForm.querySelectorAll('.fliter-tags-checkbox');
	const blogCategorySelectorEl = filterForm.querySelector('#blogCategories');
	const blogSortbySelectorEl = filterForm.querySelector('#blogSortby');

	const blogContext = filterForm.querySelector('#blogContext').value;

	let controller = new AbortController();
	let isSearching = false;

	const perPage = 12;
	// let resultsData = [];
	let resultsData = '';
	let totalResultPages = 0;
	let currentPage = 1;
	let filterCounter = 0;

	const performSearch = (cPage = 1) => {
		const tags = Array.from(filterForm.querySelectorAll('.fliter-tags-checkbox:checked')).map((el) => el.value);

		const urlObj = new URL(window.location);
		const defaultParams = ['page', 'search', 'categories', 'sortby', 'filters', 'context'];
		defaultParams.forEach((e) => urlObj.searchParams.delete(e));
		let urlName = `${urlObj.pathname}?`;
		if (urlObj.search) {
			urlName = `${urlObj.pathname + urlObj.search}&`;
		}

		window.history.pushState('', '', `${urlName}page=${cPage}&search=${blogInputEl.value}&categories=${blogCategorySelectorEl.value}&sortby=${blogSortbySelectorEl.value}&filters=${tags}&context=${blogContext}`);

		const params = {
			page: cPage,
			blogSearch: blogInputEl.value,
			blogCategories: blogCategorySelectorEl.value,
			blogSortby: blogSortbySelectorEl.value,
			blogFilters: tags,
			context: blogContext,
			_t: Date.now(),
			includePastPageResults: 1,
		};

		fetchArticles(params).then((data) => {
			const { page, results, total, totalPages, from, to } = data;

			totalResultPages = totalPages;

			if (total === 0) {
				blogNoResultsEl.classList.remove('hidden');
				blogResultsContainerEl.classList.add('hidden');

				informationTextEl.classList.add('!hidden');
			} else {
				blogResultsContainerEl.classList.remove('hidden');
				blogNoResultsEl.classList.add('hidden');

				informationTextEl.classList.remove('!hidden');
				informationTextEl.innerHTML = from && to && total ? `show ${from} - ${to} of ${total}` : '';
			}

			if (totalPages > 1 && page < totalPages) {
				blogPagingEl.classList.remove('hidden');
			} else {
				blogPagingEl.classList.add('hidden');
			}

			if (cPage === 1) {
				// console.log('a');
				resultsData = results;
			}

			if (cPage !== parseInt(currentPage)) {
				// console.log('b');
				resultsData = results;
				currentPage = cPage;
			}

			searchResultsEl.innerHTML = resultsData.trim();
		});
	};

	const doSearch = debounce((cPage = 1) => {
		if (isSearching) {
			controller.abort();
			controller = new AbortController();
			isSearching = false;
		}
		performSearch(cPage);
	});

	filterForm.addEventListener('submit', function (e) {
		e.preventDefault();
		e.stopPropagation();
		doSearch();
	});

	blogInputEl.addEventListener('keyup', () => {
		doSearch();
	});

	blogInputEl.addEventListener('change', () => {
		doSearch();
	});

	blogInputEl.addEventListener('input', (e) => {
		const val = e.currentTarget.value;
		if (!val) {
			doSearch();
		}
	});

	filterTagsEls.forEach((item) => {
		item.addEventListener('change', (event) => {
			doSearch();

			if (!event.currentTarget.checked && filterCounter > 0) {
				filterCounter -= 1;
			} else {
				filterCounter += 1;
			}
			filterCountEl.innerHTML = `${filterCounter} filters`;
		});
	});

	blogCategorySelectorEl.addEventListener('change', (event) => {
		doSearch();

		if (event.target.value.toLowerCase() === 'all' && filterCounter > 0) {
			filterCounter -= 1;
		} else {
			filterCounter += 1;
		}
		filterCountEl.innerHTML = `${filterCounter} filters`;
	});

	blogSortbySelectorEl.addEventListener('change', (event) => {
		doSearch();

		if (event.target.value === 'modResource.publishedon' && filterCounter > 0) {
			filterCounter -= 1;
		} else {
			filterCounter += 1;
		}
		filterCountEl.innerHTML = `${filterCounter} filters`;
	});

	const moreTagTriggerEl = filterForm.querySelector('.js-blog-tag-more');
	if (moreTagTriggerEl) {
		const filterMoreTagEls = filterTagsContainerEl.querySelectorAll('.more-checkbox-tag');
		moreTagTriggerEl.addEventListener('click', (event) => {
			const target = event.currentTarget;

			filterMoreTagEls.forEach((item) => {
				item.classList.remove('md:hidden');
			});
			target.remove();
		});
	}

	resetBlogFilterBtn.addEventListener('click', (event) => {
		event.preventDefault();

		filterTagsEls.forEach((item) => {
			if (item.checked) {
				// eslint-disable-next-line no-param-reassign
				item.checked = false;
				// console.log(item);

				if ('createEvent' in document) {
					const evt = document.createEvent('HTMLEvents');
					evt.initEvent('change', false, true);
					item.dispatchEvent(evt);
				} else {
					item.fireEvent('onchange');
				}
			}
		});

		blogCategorySelectorEl.value = 'All';
		blogSortbySelectorEl.value = 'modResource.publishedon';
		if ('createEvent' in document) {
			const evt = document.createEvent('HTMLEvents');
			evt.initEvent('change', false, true);
			blogCategorySelectorEl.dispatchEvent(evt);
			blogSortbySelectorEl.dispatchEvent(evt);
		} else {
			blogCategorySelectorEl.fireEvent('onchange');
			blogSortbySelectorEl.fireEvent('onchange');
		}
	});

	blogPagingEl.querySelector('a').addEventListener('click', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (currentPage < totalResultPages) {
			// currentPage += 1;
			doSearch(currentPage + 1);
		}
	});

	window.addEventListener('load', (event) => {
		const currentURL = new URL(window.location.href);
		const urlparams = currentURL.searchParams;
		const queryparams = Object.fromEntries([...urlparams]);

		if (queryparams.filters) {
			const tagsArray = queryparams.filters ? queryparams.filters.split(',') : [];

			filterTagsEls.forEach(function (item) {
				item.checked = tagsArray.includes(item.value);
			});
		}

		if (queryparams.categories) {
			blogCategorySelectorEl.value = queryparams.categories;
		}
		if (queryparams.sortby) {
			blogSortbySelectorEl.value = queryparams.sortby;
		}
		if (queryparams.search) {
			blogInputEl.value = queryparams.search;
		}

		const qsPage = parseInt(queryparams.page);
		doSearch(qsPage >= 1 ? qsPage : 1);
	});
}
